module.exports = __webpack_public_path__ + "img/icon-facebook.8354e264.svg";